__turbopack_context__.v({
  "container": "RootWrapper-module-scss-module__84tXeW__container",
  "contentContainer": "RootWrapper-module-scss-module__84tXeW__contentContainer",
  "loading": "RootWrapper-module-scss-module__84tXeW__loading",
  "sideBarContainer": "RootWrapper-module-scss-module__84tXeW__sideBarContainer",
});
